import { Text } from "@/components/Text";
import { ClassesEnum } from "@/ts/enums/ClassesEnum";
import { getTrackingId } from "@/utils/utils";
import AlertIcon from "@icons/AlertIcon";
import SuccessIcon from "@icons/SuccessIcon";

import { Button, Flex, Link } from "@chakra-ui/react";

interface PropTypes {
    serviceName: string;
    addonTextbookLink: string;
    redirectsTo: string;
    isBulkAddon: boolean;
}

const ChargePurchaseSuccess = ({
    addonTextbookLink,
    serviceName,
    redirectsTo,
    isBulkAddon
}: PropTypes) => {
    return (
        <Flex
            align="center"
            mt={16}
            direction="column"
            gap={7}
            px={[5, null, null, 0]}
            data-tracking-id={getTrackingId(
                [ClassesEnum.CheckoutContainer],
                "chargePurchaseSuccess"
            )}
        >
            <SuccessIcon width={64} height={64} />
            <Text type="heading" mt={2} textAlign="center">
                Premium service added successfully
            </Text>
            <Text fontSize={16} textAlign="center">
                Thank you for adding the{" "}
                {isBulkAddon ? serviceName + "s" : serviceName} to your
                enrolment
            </Text>
            <Flex
                direction="column"
                gap={4}
                w={["98%", null, 600]}
                bg="gray.50"
                border="1px solid"
                borderColor="gray.300"
                px={[5, null, 14]}
                py={[8, null, 10]}
                borderRadius={25}
            >
                <Flex gap={4} align="center">
                    <AlertIcon width={24} height={24} />
                    <Text
                        fontSize={18}
                        fontFamily="infini, sans-serif"
                        fontWeight="bold"
                    >
                        Your next steps:
                    </Text>
                </Flex>
                <Flex as="ul" direction="column" gap={3} pl={6}>
                    <li>
                        <Text left={4} position="relative">
                            <b>Check your email</b> for information about how to
                            get started with the{" "}
                            {isBulkAddon ? serviceName + "s" : serviceName}
                        </Text>
                    </li>
                    <li>
                        <Text left={4} position="relative">
                            <Link
                                href={addonTextbookLink}
                                target="_blank"
                                textDecor="underline"
                            >
                                Download our {serviceName} Handbook
                            </Link>{" "}
                            for an overview of the service, requirements and the
                            process.
                        </Text>
                    </li>
                </Flex>
            </Flex>
            <Button
                onClick={() => {
                    window.location.href = redirectsTo;
                }}
                colorScheme="ebonyClay"
            >
                Got it, thanks
            </Button>
        </Flex>
    );
};

export default ChargePurchaseSuccess;
